'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroup$002dRestrictions$002dView$0024$0024anon$002449 from "./presto.-Group-Restrictions-View$$anon$49.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$0024 from "./presto.types$-Grouping$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dDescription$0024 from "./presto.types$-Grouping-Description$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dId$0024 from "./presto.types$-Grouping-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dKind$0024 from "./presto.types$-Grouping-Kind$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024 from "./presto.types$-Grouping-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupRestrictionsView$$anon$48() {
  this.aV4 = null;
  this.aUW = null;
  this.aUX = false;
  this.aV5 = null;
  this.aV6 = false;
  this.aV9 = null;
  this.aV2 = null;
  this.aV3 = false;
  this.aUY = null;
  this.aUZ = false;
  this.aV0 = null;
  this.aV1 = false;
  this.aV7 = false;
  this.aV8 = false;
  this.aV4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aV9 = "Grouping";
}
export { $c_Lpresto_GroupRestrictionsView$$anon$48 as $c_Lpresto_GroupRestrictionsView$$anon$48 };
$p = $c_Lpresto_GroupRestrictionsView$$anon$48.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupRestrictionsView$$anon$48;
/** @constructor */
function $h_Lpresto_GroupRestrictionsView$$anon$48() {
}
export { $h_Lpresto_GroupRestrictionsView$$anon$48 as $h_Lpresto_GroupRestrictionsView$$anon$48 };
$h_Lpresto_GroupRestrictionsView$$anon$48.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aV4;
});
$p.M = (function() {
  if ((!this.aUX)) {
    this.aUW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aUX = true;
  }
  return this.aUW;
});
$p.O = (function() {
  if ((!this.aV6)) {
    this.aV5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aV6 = true;
  }
  return this.aV5;
});
$p.E = (function() {
  return this.aV9;
});
$p.t = (function() {
  if ((!this.aV3)) {
    this.aV2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("description", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.aV3 = true;
  }
  return this.aV2;
});
$p.N = (function() {
  if ((!this.aUZ)) {
    this.aUY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dId$0024.$m_Lpresto_types$GroupingId$().nL(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dGrouping$002dKind$0024.$m_Lpresto_types$GroupingKind$().p4())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dName$0024.$m_Lpresto_types$GroupingName$().nM(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dDescription$0024.$m_Lpresto_types$GroupingDescription$().p3(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.aUZ = true;
  }
  return this.aUY;
});
$p.Q = (function() {
  if ((!this.aV1)) {
    this.aV0 = new $j_presto$002e$002dGroup$002dRestrictions$002dView$0024$0024anon$002449.$c_Lpresto_GroupRestrictionsView$$anon$49();
    this.aV1 = true;
  }
  return this.aV0;
});
$p.v = (function() {
  if ((!this.aV8)) {
    this.aV7 = false;
    this.aV8 = true;
  }
  return this.aV7;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee310) => ((p) => \u03b4scrutinee310.oZ(p)))($j_presto$002etypes$0024$002dGrouping$0024.$m_Lpresto_types$Grouping$())));
});
var $d_Lpresto_GroupRestrictionsView$$anon$48 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupRestrictionsView$$anon$48, "presto.GroupRestrictionsView$$anon$48", ({
  Jq: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_GroupRestrictionsView$$anon$48 as $d_Lpresto_GroupRestrictionsView$$anon$48 };
//# sourceMappingURL=presto.-Group-Restrictions-View$$anon$48.js.map
